// ABOUTME: The shipment figures panel: what a period sent out, beside those shipments over time.
// ABOUTME: forRelation swaps the shipper card for returns; a relation session is scoped by the API.

import { useTranslation } from "react-i18next";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import PublicIcon from '@mui/icons-material/Public';

import ShTotalsPanel from "../../theme/cards/ShTotalsPanel";
import { useGetShipmentDashboardChartQuery, useGetShipmentDashboardTotalsQuery } from "../../../newapi/dashboard/dashboardSlice";

const ShipmentTotalsPanel = ({ forRelation = false }) => {
    const { t } = useTranslation();

    // Which shippers are used is the warehouse's choice, so a relation reads its returns there.
    const thirdCard = forRelation
        ? { key: "returnCount", label: t("returns"), icon: <AssignmentReturnOutlinedIcon className="logo"/>, color: "orange", type: "number" }
        : { key: "shipperCount", label: t("shippers"), icon: <BusinessOutlinedIcon className="logo"/>, color: "orange", type: "number" };

    return (
        <ShTotalsPanel
            useTotals={useGetShipmentDashboardTotalsQuery}
            useChart={useGetShipmentDashboardChartQuery}
            chartSubtitles={{
                month: t("shipments_per_month"),
                week: t("shipments_per_week")
            }}
            chartSeries={[
                { type: "number" },
                { type: "number", chartType: "hidden" },
                { type: "number", chartType: "hidden" },
            ]}
            cards={[
                { key: "shipmentCount", label: t("shipments"), icon: <LocalShippingIcon className="logo"/>, color: "blue", type: "number" },
                { key: "orderCount", label: t("orders"), icon: <ShoppingBagOutlinedIcon className="logo"/>, color: "purple", type: "number" },
                thirdCard,
                { key: "countryCount", label: t("countries"), icon: <PublicIcon className="logo"/>, color: "green", type: "number" },
            ]}
        />
    );
};

export default ShipmentTotalsPanel;
